var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAdmin)?_c('div',[_c('LoadingIcon',{attrs:{"isLoading":_vm.isLoading}}),(_vm.userId)?_c('LeverancierDetailsForm',{attrs:{"supplier":_vm.supplier},on:{"save":_vm.addNewSupplier}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }